<template>
    <div class="gpt-event-branding-drawer">
        <div class="banner-drawer-head">
            <h3>Banner Image</h3>
            <v-btn @click="closeBrandingPanel()" fab text x-small><v-icon color="#5a646e" size="22px">mdi-close</v-icon></v-btn>
        </div>
        <p>Select from the below options to change the banner of your event</p>
        <div class="banner-options-wrap">
            <div class="single-banner-option">
                <h4>Banner option 1</h4>
                <div class="branding-banner">
                    <img src="../assets/Images/chatgpt/braning-banner1.jpg"/>
                    <div class="select-branding-overlay">
                        <span><v-icon color="#2376e5" size="25px">mdi-check</v-icon></span>
                    </div>
                </div>
            </div>
            <div class="single-banner-option">
                <h4>Banner option 2</h4>
                <div class="branding-banner">
                    <img src="../assets/Images/chatgpt/branding-banner2.jpg"/>
                    <div class="select-branding-overlay">
                        <span><v-icon color="#2376e5" size="25px">mdi-check</v-icon></span>
                    </div>
                </div>
            </div>
            <div class="single-banner-option">
                <h4>Banner option 3</h4>
                <div class="branding-banner">
                    <img src="../assets/Images/chatgpt/branding-banner3.jpg"/>
                    <div class="select-branding-overlay">
                        <span><v-icon color="#2376e5" size="25px">mdi-check</v-icon></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    components: {
    },
    props: {
        visible: {
        type: Boolean,
        required: true
        }
    },
    data() {
        return {
        }
    },
    computed: {
        
    },
    watch: {},
    created() {},
    mounted() {},
    methods: {
        closeBrandingPanel(){
            this.$parent.brandingDrawer = false; 
        }
    },

}
</script>